define.alias("shared/components/shared/social-set-icons", "calendar/components/shared/social-set-icons");